import React, { useEffect, useMemo, useState } from "react";

import {
  AvatarViewBlockCard,
  CountDownViewBlockCard,
  DividerViewBlockCard,
  FaqViewBlockCard,
  HeaderTextBlockCard,
  HeadingViewBlockCard,
  ImageGridViewBlockCard,
  ImageViewBlockCard,
  InstaViewBlockCard,
  LinkViewBlockCard,
  ShareViewBlockCard,
  SocialViewBlockCard,
  TikTokViewBlockCard,
  TwitterViewBlockCard,
  YoutubeViewBlockCard,
} from "./index";
import { ReactComponent as TrashIcon } from "../../../../../assets/MainPage/viewBlocks/trash.svg";
import { ReactComponent as TrashIconDark } from "../../../../../assets/MainPage/viewBlocks/trash-dark.svg";
// redux
import { useDispatch, useSelector } from "react-redux";
import { sortBlocksLink } from "../../../../../redux/slices/block/sortBlockSlice";
import {
  gettingLinkList,
  resetLinkList,
} from "../../../../../redux/slices/gettingLinksList/gettingLinkListSlice";
import {
  gettingBioLink,
  resetLink,
} from "../../../../../redux/slices/getLink/getLinkSlice";
import { gettingLinkPreview } from "../../../../../redux/slices/linkPreview/linkPreviewSlice";

// dnd kit
import {
  DndContext,
  useSensors,
  useSensor,
  PointerSensor,
  KeyboardSensor,
  closestCenter,
} from "@dnd-kit/core";
import {
  arrayMove,
  SortableContext,
  sortableKeyboardCoordinates,
} from "@dnd-kit/sortable";
import { DragOverlay, defaultDropAnimationSideEffects } from "@dnd-kit/core";
import {
  deleteMultiBlocks as deleteMultiBlocksFun,
  resetDeleteMultiBlocks,
} from "../../../../../redux/slices/block/deleteBlockSlice";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import LocationBlockCard from "./LocationBlockCard";
import useLocales from "../../../../../hooks/useLocales";

const dropAnimationConfig = {
  sideEffects: defaultDropAnimationSideEffects({
    styles: {
      active: {
        opacity: "0.4",
      },
    },
  }),
};

export function SortableOverlay({ children }) {
  return (
    <DragOverlay dropAnimation={dropAnimationConfig}>{children}</DragOverlay>
  );
}

const ViewBlocksTabArea = ({ mylinkstateSorted }) => {
  const { darkMode } = useSelector((state) => state.theme);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { currentLang , translate } = useLocales();

  const { success } = useSelector(
    (state) => state?.gettingBioLinksState?.getBioLink
  );
  const [ids, setIds] = useState([]);
  const checkBoxChangeHandler = (id) => {
    setIds((prev) => {
      if (prev.includes(id)) {
        // If the id is already in the array, remove it.
        return prev.filter((existingId) => existingId !== id);
      } else {
        // If the id is not in the array, add it.
        return [...prev, id];
      }
    });
  };
  useEffect(() => {
    dispatch(gettingBioLink()).then(() => {
      dispatch(resetLink());
    });
    fetchingLinkList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // _________________fetching All block link list data ____________
  useEffect(() => {
    setTimeout(() => {
      fetchingLinkList();
    }, 100);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [success]);

  const getLinkState = useSelector((state) => state?.gettingBioLinksState);

  const fetchingLinkList = async () => {
    const linkId =
      localStorage.getItem("linkId") ||
      getLinkState?.getBioLink?.response?.[0]?._id;
    const user = JSON.parse(localStorage.getItem("user"));
    const userId = user.userid;
    const usertoken = user.token;
    const linkListData = {
      userId,
      usertoken,
      linkId,
    };
    await dispatch(gettingLinkList(linkListData));
    dispatch(resetLinkList());
  };
  const sortBlockLink = async (reorderedItems) => {
    await dispatch(sortBlocksLink(reorderedItems));
    dispatch(resetLinkList());
  };

  const [blocks, setBlocks] = useState([]);

  
  const filteredLinkData = blocks?.filter(
    (item) => item?.language === currentLang.value
  );

  const user_data = useSelector(
    (state) => state?.adminUser?.viewUserData?.user_data
  );
  useEffect(() => {
    if (mylinkstateSorted) {
      setBlocks(mylinkstateSorted);
    } else {
      setBlocks([]);
    }
    // console.log(blocks, "blocks sorted");
  }, [mylinkstateSorted]);

  // console.log(mylinkstateSorted, "mylinkstateSorted", blocks, "blocks sorted");

  const [active, setActive] = useState(null);
  const activeItem = useMemo(
    () => filteredLinkData?.find((item) => item?._id === active?.id),
    [active, filteredLinkData]
  );

  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  );

  function handleDragEnd(event) {
    const { active, over } = event;
    if (over && active.id !== over?.id) {
      let reorderedItems;

      setBlocks((prev) => {
        const activeIndex = prev.findIndex((item) => item._id === active?.id);
        const overIndex = prev.findIndex((item) => item._id === over?.id);
        reorderedItems = arrayMove(prev, activeIndex, overIndex);
        return arrayMove(prev, activeIndex, overIndex);
      });
      // console.log(reorderedItems, "reorderedItems");
      sortBlockLink(reorderedItems);
      dispatch(gettingLinkPreview(user_data?.pageName));
      fetchingLinkList();
    }
    setActive(null);
  }
  // mylinkstate?.getLinkList?.linkListLoading
  const { linkListError, linkListLoading } = useSelector(
    (state) => state?.linkList
  );
  useEffect(() => {
    if (linkListError) {
      navigate("/500");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [linkListLoading]);
  const linkId = localStorage.getItem("linkId");
  const user = JSON.parse(localStorage.getItem("user"));
  const userId = user.userid;
  const fetchingLinksList = () => {
    // data need for fetching link list
    const usertoken = user.token;
    const linkListData = {
      userId,
      usertoken,
      linkId,
    };
    dispatch(gettingLinkList(linkListData));
  };

  const deleteBlocks = async () => {
    const obj = {
      ids: ids,
    };
    await dispatch(deleteMultiBlocksFun(obj));
    await dispatch(resetDeleteMultiBlocks());
    setIds([]);
  };

  const {
    deleteMultiBlocks,
    isDeleteMultiBlocksError,
    isDeleteMultiBlocksSuccess,
    isDeleteMultiBlocksLoading,
    isDeleteMultiBlocksErrorMsg,
  } = useSelector((state) => state?.deleteBlock);
  useEffect(() => {
    if (
      deleteMultiBlocks?.data?.status === "success" &&
      isDeleteMultiBlocksSuccess
    ) {
      toast.success(deleteMultiBlocks?.data?.message);
      fetchingLinksList();
    }
    if (
      deleteMultiBlocks?.data?.status === "failed" &&
      isDeleteMultiBlocksSuccess
    ) {
      toast.error(deleteMultiBlocks?.data?.message);
    }
    if (isDeleteMultiBlocksError) {
      toast.error(isDeleteMultiBlocksErrorMsg);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDeleteMultiBlocksLoading, deleteMultiBlocks]);

  return (
    <>
      <div className="py-7 px-6 md:px-0">
        {linkListLoading ? (
          <div className="flex flex-col gap-4 my-4">
            {/* loading cards -- */}
            <div className="animate-pulse rounded-lg md:rounded-[10px] shadow-shadow_2 md:shadow-shadow bg-white p-3 md:py-3 md:px-[15px] flex items-center gap-[13px] md:gap-3">
              <div className="h-[20px] w-[5px] bg-slate-200 rounded-full "></div>
              <div>
                <div className="max-h-[36px] min-h-[36px] h-[36px] max-w-[36px] min-w-[36px] w-[36px] rounded-lg bg-slate-200"></div>
              </div>
              <div className="w-full flex gap-3 justify-between">
                <div className="space-y-1 w-full">
                  <div className="grid grid-cols-3">
                    <div className="h-3 bg-slate-200 rounded "></div>
                  </div>
                  <div className="h-2 bg-slate-200 rounded"></div>
                </div>
              </div>
            </div>
            <div className="animate-pulse rounded-lg md:rounded-[10px] shadow-shadow_2 md:shadow-shadow bg-white p-3 md:py-3 md:px-[15px] flex items-center gap-[13px] md:gap-3">
              <div className="h-[20px] w-[5px] bg-slate-200 rounded-full "></div>
              <div>
                <div className="max-h-[36px] min-h-[36px] h-[36px] max-w-[36px] min-w-[36px] w-[36px] rounded-lg bg-slate-200"></div>
              </div>
              <div className="w-full flex gap-3 justify-between">
                <div className="space-y-1 w-full">
                  <div className="grid grid-cols-3">
                    <div className="h-3 bg-slate-200 rounded "></div>
                  </div>
                  <div className="h-2 bg-slate-200 rounded"></div>
                </div>
              </div>
            </div>
            <div className="animate-pulse rounded-lg md:rounded-[10px] shadow-shadow_2 md:shadow-shadow bg-white p-3 md:py-3 md:px-[15px] flex items-center gap-[13px] md:gap-3">
              <div className="h-[20px] w-[5px] bg-slate-200 rounded-full "></div>
              <div>
                <div className="max-h-[36px] min-h-[36px] h-[36px] max-w-[36px] min-w-[36px] w-[36px] rounded-lg bg-slate-200"></div>
              </div>
              <div className="w-full flex gap-3 justify-between">
                <div className="space-y-1 w-full">
                  <div className="grid grid-cols-3">
                    <div className="h-3 bg-slate-200 rounded "></div>
                  </div>
                  <div className="h-2 bg-slate-200 rounded"></div>
                </div>
              </div>
            </div>
            <div className="animate-pulse rounded-lg md:rounded-[10px] shadow-shadow_2 md:shadow-shadow bg-white p-3 md:py-3 md:px-[15px] flex items-center gap-[13px] md:gap-3">
              <div className="h-[20px] w-[5px] bg-slate-200 rounded-full "></div>
              <div>
                <div className="max-h-[36px] min-h-[36px] h-[36px] max-w-[36px] min-w-[36px] w-[36px] rounded-lg bg-slate-200"></div>
              </div>
              <div className="w-full flex gap-3 justify-between">
                <div className="space-y-1 w-full">
                  <div className="grid grid-cols-3">
                    <div className="h-3 bg-slate-200 rounded "></div>
                  </div>
                  <div className="h-2 bg-slate-200 rounded"></div>
                </div>
              </div>
            </div>
            <div className="animate-pulse rounded-lg md:rounded-[10px] shadow-shadow_2 md:shadow-shadow bg-white p-3 md:py-3 md:px-[15px] flex items-center gap-[13px] md:gap-3">
              <div className="h-[20px] w-[5px] bg-slate-200 rounded-full "></div>
              <div>
                <div className="max-h-[36px] min-h-[36px] h-[36px] max-w-[36px] min-w-[36px] w-[36px] rounded-lg bg-slate-200"></div>
              </div>
              <div className="w-full flex gap-3 justify-between">
                <div className="space-y-1 w-full">
                  <div className="grid grid-cols-3">
                    <div className="h-3 bg-slate-200 rounded "></div>
                  </div>
                  <div className="h-2 bg-slate-200 rounded"></div>
                </div>
              </div>
            </div>
            {/* loading cards -- ends */}
          </div>
        ) : filteredLinkData?.length <= 0 ? (
          <div className="text-heading_color text-center">
            <p className=" text-small1_bold lg:text-body_copy2_black dark:text-color_v1_dark">
              {translate("no_blocks_found")}
            </p>
          </div>
        ) : (
          <>
            <DndContext
              sensors={sensors}
              collisionDetection={closestCenter}
              onDragStart={({ active }) => {
                setActive(active);
              }}
              onDragEnd={handleDragEnd}
              onDragCancel={() => {
                setActive(null);
              }}
            >
              <SortableContext items={filteredLinkData}>
                <ul
                  className="my-4 mb-5 md:mb-6 grid grid-cols-1 gap-4"
                  role="application"
                >
                  {filteredLinkData?.map((item, i) => {
                    switch (item.coloum_name) {
                      case "link":
                        return (
                          <LinkViewBlockCard
                            key={item?._id}
                            item={item}
                            checkBoxChangeHandler={checkBoxChangeHandler}
                            ids={ids}
                          />
                        );
                      case "avatar":
                        return (
                          <AvatarViewBlockCard
                            key={item?._id}
                            item={item}
                            checkBoxChangeHandler={checkBoxChangeHandler}
                            ids={ids}
                          />
                        );
                      case "share":
                        return (
                          <ShareViewBlockCard
                            key={item?._id}
                            item={item}
                            checkBoxChangeHandler={checkBoxChangeHandler}
                            ids={ids}
                          />
                        );
                      case "faq":
                        return (
                          <FaqViewBlockCard
                            key={item?._id}
                            item={item}
                            checkBoxChangeHandler={checkBoxChangeHandler}
                            ids={ids}
                          />
                        );
                      case "youtube":
                        return (
                          <YoutubeViewBlockCard
                            key={item?._id}
                            item={item}
                            checkBoxChangeHandler={checkBoxChangeHandler}
                            ids={ids}
                          />
                        );
                      case "tiktok":
                        return (
                          <TikTokViewBlockCard
                            key={item?._id}
                            item={item}
                            checkBoxChangeHandler={checkBoxChangeHandler}
                            ids={ids}
                          />
                        );
                      case "instagram":
                        return (
                          <InstaViewBlockCard
                            key={item?._id}
                            item={item}
                            checkBoxChangeHandler={checkBoxChangeHandler}
                            ids={ids}
                          />
                        );
                      case "twitter":
                        return (
                          <TwitterViewBlockCard
                            key={item?._id}
                            item={item}
                            checkBoxChangeHandler={checkBoxChangeHandler}
                            ids={ids}
                          />
                        );
                      case "image":
                        return (
                          <ImageViewBlockCard
                            key={item?._id}
                            item={item}
                            checkBoxChangeHandler={checkBoxChangeHandler}
                            ids={ids}
                          />
                        );
                      case "imageGrid":
                        return (
                          <ImageGridViewBlockCard
                            key={item?._id}
                            item={item}
                            checkBoxChangeHandler={checkBoxChangeHandler}
                            ids={ids}
                          />
                        );
                      case "divider":
                        return (
                          <DividerViewBlockCard
                            key={item?._id}
                            item={item}
                            checkBoxChangeHandler={checkBoxChangeHandler}
                            ids={ids}
                          />
                        );
                      case "countdown":
                        return (
                          <CountDownViewBlockCard
                            key={item?._id}
                            item={item}
                            checkBoxChangeHandler={checkBoxChangeHandler}
                            ids={ids}
                          />
                        );
                      case "heading":
                        return (
                          <HeadingViewBlockCard
                            key={item?._id}
                            item={item}
                            checkBoxChangeHandler={checkBoxChangeHandler}
                            ids={ids}
                          />
                        );
                      case "social":
                        return (
                          <SocialViewBlockCard
                            key={item?._id}
                            item={item}
                            checkBoxChangeHandler={checkBoxChangeHandler}
                            ids={ids}
                          />
                        );
                      case "headertext":
                        return (
                          <HeaderTextBlockCard
                            key={item?._id}
                            item={item}
                            checkBoxChangeHandler={checkBoxChangeHandler}
                            ids={ids}
                          />
                        );
                        case "mapData":
                          return (
                            <LocationBlockCard
                              key={item?._id}
                              item={item}
                              checkBoxChangeHandler={checkBoxChangeHandler}
                              ids={ids}
                            />
                          );
                      default:
                        return null;
                    }
                  })}
                </ul>
              </SortableContext>
              <SortableOverlay>
                {activeItem
                  ? (() => {
                      switch (activeItem.coloum_name) {
                        case "link":
                          return (
                            <div>
                              <ul>
                                <LinkViewBlockCard
                                  key={activeItem?._id}
                                  item={activeItem}
                                />
                              </ul>
                            </div>
                          );
                        case "avatar":
                          return (
                            <div>
                              <ul>
                                <AvatarViewBlockCard
                                  key={activeItem?._id}
                                  item={activeItem}
                                />
                              </ul>
                            </div>
                          );
                        case "share":
                          return (
                            <div>
                              <ul>
                                <ShareViewBlockCard
                                  key={activeItem?._id}
                                  item={activeItem}
                                />
                              </ul>
                            </div>
                          );
                        case "youtube":
                          return (
                            <div>
                              <ul>
                                <YoutubeViewBlockCard
                                  key={activeItem?._id}
                                  item={activeItem}
                                />
                              </ul>
                            </div>
                          );
                        case "heading":
                          return (
                            <div>
                              <ul>
                                <HeadingViewBlockCard
                                  key={activeItem?._id}
                                  item={activeItem}
                                />
                              </ul>
                            </div>
                          );
                        case "social":
                          return (
                            <div>
                              <ul>
                                <SocialViewBlockCard
                                  key={activeItem?._id}
                                  item={activeItem}
                                />
                              </ul>
                            </div>
                          );
                        case "faq":
                          return (
                            <div>
                              <ul>
                                <FaqViewBlockCard
                                  key={activeItem?._id}
                                  item={activeItem}
                                />
                              </ul>
                            </div>
                          );
                        case "tiktok":
                          return (
                            <div>
                              <ul>
                                <TikTokViewBlockCard
                                  key={activeItem?._id}
                                  item={activeItem}
                                />
                              </ul>
                            </div>
                          );
                        case "instagram":
                          return (
                            <div>
                              <ul>
                                <InstaViewBlockCard
                                  key={activeItem?._id}
                                  item={activeItem}
                                />
                              </ul>
                            </div>
                          );
                        case "twitter":
                          return (
                            <div>
                              <ul>
                                <TwitterViewBlockCard
                                  key={activeItem?._id}
                                  item={activeItem}
                                />
                              </ul>
                            </div>
                          );
                        case "image":
                          return (
                            <div>
                              <ul>
                                <ImageViewBlockCard
                                  key={activeItem?._id}
                                  item={activeItem}
                                />
                              </ul>
                            </div>
                          );
                        case "imageGrid":
                          return (
                            <div>
                              <ul>
                                <ImageGridViewBlockCard
                                  key={activeItem?._id}
                                  item={activeItem}
                                />
                              </ul>
                            </div>
                          );
                        case "divider":
                          return (
                            <div>
                              <ul>
                                <DividerViewBlockCard
                                  key={activeItem?._id}
                                  item={activeItem}
                                />
                              </ul>
                            </div>
                          );
                        case "countdown":
                          return (
                            <div>
                              <ul>
                                <CountDownViewBlockCard
                                  key={activeItem?._id}
                                  item={activeItem}
                                />
                              </ul>
                            </div>
                          );

                        default:
                          return null;
                      }
                    })()
                  : null}
              </SortableOverlay>
            </DndContext>
            {filteredLinkData?.length > 0 && ids?.length > 0 && (
              <div className="flex justify-end">
                <button
                  type="button"
                  onClick={() => deleteBlocks()}
                  className={`text-dark_bg_v2 border border-dark_bg_v2 dark:border-color_v1_dark  rounded-full text-small3_b md:text-small2_b px-[22px] md:px-[26px] pt-[5px] md:pt-[7px] pb-[6px] md:pb-[8px] flex items-center gap-2 ${
                    isDeleteMultiBlocksLoading ? "opacity-70" : ""
                  }`}
                  disabled={isDeleteMultiBlocksLoading}
                >
                  {isDeleteMultiBlocksLoading ? (
                    <svg
                      aria-hidden="true"
                      role="status"
                      className="inline w-3 h-3 text-heading_color dark:text-color_v1_dark animate-spin"
                      viewBox="0 0 100 101"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                        fill="#00000022"
                      />
                      <path
                        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                        fill="currentColor"
                      />
                    </svg>
                  ) : darkMode ? (
                    <TrashIconDark className="w-[15px] h-[15px] md:h-[18px] md:w-[18px]" />
                  ) : (
                    <TrashIcon className="w-[15px] h-[15px] md:h-[18px] md:w-[18px]" />
                  )}
                  <p className="pt-0.5 md:pt-1 dark:text-color_v1_dark">
                    DELETE
                  </p>
                </button>
              </div>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default ViewBlocksTabArea;
